import { Action } from '@ngrx/store';
import {AddUpdateDeviceParams, MiniCardInfo, MiniCardParams} from '../../../models/devices';

export enum BindMiniCardActionTypes {
  LoadBindMiniCards = '[BindMiniCard] Load BindMiniCards',
  GetBindMiniCards = '[BindMiniCard] Get BindMiniCards',
  ClearMiniCards = '[BindMiniCard] Clear BindMiniCards',
}

export class LoadBindMiniCards implements Action {
  readonly type = BindMiniCardActionTypes.LoadBindMiniCards;
  constructor(public payload: AddUpdateDeviceParams) {}
}

export class GetBindMiniCards implements Action {
  readonly type = BindMiniCardActionTypes.GetBindMiniCards;
  constructor(public payload: MiniCardParams) {}
}

export class ClearBindMiniCards implements Action {
  readonly type = BindMiniCardActionTypes.ClearMiniCards;
}


export type BindMiniCardActions = LoadBindMiniCards
  | GetBindMiniCards
  | ClearBindMiniCards;
